import React, { createContext, useState, useContext } from 'react';
import { translations } from '@/translations/index';

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState('nl');
  const currentTranslations = translations[language];

  const t = (key) => {
    const keys = key.split('.');
    let value = currentTranslations;
    for (const k of keys) {
      if (value && value[k] !== undefined) {
        value = value[k];
      } else {
        return key; 
      }
    }
    return value;
  };
  
  const tSafe = (key, replacements = {}) => {
    let text = t(key);
    if (typeof text !== 'string') {
      console.warn(`Translation key "${key}" did not return a string for language "${language}".`);
      return key;
    }
    Object.keys(replacements).forEach(placeholder => {
      const regex = new RegExp(`{${placeholder}}`, 'g');
      text = text.replace(regex, replacements[placeholder]);
    });
    return text;
  };


  return (
    <LanguageContext.Provider value={{ language, setLanguage, t: tSafe }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);